import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import * as colendingActions from "../../actions/colendingActions";
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';

const ColendingMasterPage = (props)=>{
  const { actions } = props;
  const navigate = useNavigate();
  const [list,setList]=useState([]);

  useEffect(()=>{
    const obj={start:'0',length:config.MAX_RECORDS};
    actions.colendingData(encryptData(obj))
      .then(res=>{
        if(res.data.success===1){
          setList(res.data.data.data);
        }
      });
  },[]);

  return(
    <>
      <Helmet><title>Co-Lending Master</title></Helmet>

      <Container>
        <div className="d-flex justify-content-between">
          <span>&nbsp;</span>
          <RouterLink to="/dashboard/create-colending-master" className="btn btn-primary">
            + Add Co-Lending
          </RouterLink>
        </div>

        <Typography variant="h4" sx={{mb:2}}>Co-Lending Master</Typography>

        <table className="table">
          <thead>
            <tr>
              <th>Identifier</th>
              <th>Lender 1</th>
              <th>Lender 2</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {list.map(row=>(
              <tr key={row.id}>
                <td>{row.identifier}</td>
                <td>{row.lender1_name}</td>
                <td>{row.lender2_name}</td>
                <td>
                  <RouterLink to={`/dashboard/edit-colending-master/${btoa(row.id)}`}>
                    Edit
                  </RouterLink>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Container>
    </>
  )
}
 
function mapDispatch(dispatch){
  return{
    actions:bindActionCreators(
      Object.assign(colendingActions.default,userActions.default),
      dispatch
    )
  }
}

export default connect(null,mapDispatch)(ColendingMasterPage);